import covers from 'virtual:reader-covers';

const absolute=file=>new URL(file,document.baseURI).href;
const openingSizes=cover=>`${Math.min(220,300*cover.width/cover.height)}px`;
export function bookCover(book){return !book.imported?covers[book.id]:null;}
export function coverMetadata(book){
  const cover=bookCover(book);if(!cover)return book;
  return {...book,cover:absolute(cover.variants.find(v=>v.width>=240)?.file||cover.variants.at(-1).file),
    coverWidth:cover.width,coverHeight:cover.height,
    coverSrcset:cover.variants.map(v=>`${absolute(v.file)} ${v.width}w`).join(', ')};
}
export function prepareCover(image,book){
  const cover=bookCover(book);if(!cover)return;
  const source=absolute(cover.source);
  if(image.src!==source)return;
  const meta=coverMetadata(book);
  image.dataset.readerCover='';image.width=cover.width;image.height=cover.height;
  image.sizes=openingSizes(cover);image.srcset=meta.coverSrcset;image.src=meta.cover;
  image.loading='eager';image.fetchPriority='high';image.decoding='async';
  image.style.setProperty('--opening-cover-width',`${Math.min(220,300*cover.width/cover.height)}px`);
  image.style.setProperty('--opening-cover-ratio',`${cover.width}/${cover.height}`);
}
export function preloadCover(book){
  const cover=bookCover(book);if(!cover)return;
  const meta=coverMetadata(book),link=document.createElement('link');
  link.rel='preload';link.as='image';link.href=meta.cover;link.imageSrcset=meta.coverSrcset;
  link.imageSizes=openingSizes(cover);link.fetchPriority='high';document.head.append(link);
  return ()=>link.remove();
}
export function coverUrls(book){return bookCover(book)?.variants.map(v=>absolute(v.file))||[];}
